import { render, staticRenderFns } from "./employeeslistcontent.vue?vue&type=template&id=1f5bb6a4"
import script from "./employeeslistcontent.vue?vue&type=script&lang=js"
export * from "./employeeslistcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports